import * as React from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';

import BackendSettings from './BackendSettings';
import ShipStrain from './ShipStrain';
import Strain from './Strain';
import Tp from './Tp'
import ParamSettings from './ParamSettings';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Home() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="バックエンド設定" {...a11yProps(0)} />
          <Tab label="パラメータおよびセンサ名称" {...a11yProps(1)} />
          <Tab label="波浪中縦曲げモーメント" {...a11yProps(2)} />
          <Tab label="応力" {...a11yProps(3)} />
          <Tab label="TP" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <BackendSettings />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ParamSettings />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Strain />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ShipStrain />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Tp />
      </CustomTabPanel>
    </Box>
  );
}